import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { makeGetCustomField } from '../selectors/custom-fields';

import { removeCustomField } from '../actions/custom-fields';

import { CUSTOM_FIELDS } from '../constants/custom-fields';

import Tooltip from './tooltip';

import IconEye from '../icons/icon-eye';
import IconRemove from '../icons/icon-remove';

class CustomFieldCard extends PureComponent {
    handleClick = () => {
        this.props.onSelect && this.props.onSelect(this.props.id);
    }

    handleRemoveClick = () => {
        removeCustomField(this.props.id);
    }

    render() {
        const { customField } = this.props;
        const fieldProps = CUSTOM_FIELDS.find(field => field.id === customField.type);

        if (!fieldProps) {
            return null;
        }

        return (
            <div className="custom-field-card">
                <div className="card-overlay" onClick={this.handleClick} />

                <div className="card-icon" style={{ color: fieldProps.color }}>
                    { fieldProps.icon }
                </div>

                <div className="card-main">
                    <div className="card-head">
                        <div className="card-title">
                            { customField.name }
                        </div>

                        <div className="card-sub">
                            <span className="tag-pill">{fieldProps.name}</span>

                            {
                                customField.hidden.length ? (
                                    <Tooltip tooltip="This field is hidden from Guests">
                                        <div className="card-meta-icon">
                                            <IconEye />
                                        </div>
                                    </Tooltip>
                                ) : null
                            }
                        </div>
                    </div>
                </div>

                <div className="card-actions">
                    <span className="card-action" onClick={this.handleRemoveClick}>
                        <IconRemove />
                    </span>
                </div>
            </div>
        );
    }
}

const makeMapStateToProps = () => {
    const getCustomField = makeGetCustomField();

    return ({ customFields }, ownProps) => ({
        customField: getCustomField(customFields.items, ownProps.id)
    })
}

export default connect(makeMapStateToProps)(CustomFieldCard);
